import $ from "jquery";

//export const HOSTNAME = "http://localhost:5000";
export const HOSTNAME = "https://app.aakhor.in";

export const getRandomWord = HOSTNAME + "/get_random_word";
export const submitCorrectWord = HOSTNAME + "/add_word";

export function FetchData(endpoint_url, data) {
  const serverUrl = HOSTNAME + endpoint_url;

  /*$.ajax({
        type: 'POST',
        url: serverUrl,
        data: {
            data: JSON.stringify(data)
        }
    })
    .done(function(res) {
        console.log(res);
        //alert(res);
    })
    .fail(function(jqXHR, exception){
            //alert('server error()');
    });*/

  return new Promise((resolve, reject) => {
    $.ajax({
      type: "POST",
      url: serverUrl,
      data
    })
      .done(function(res) {
        //console.log(res);
        resolve(res);
      })
      .fail(function(jqXHR, exception) {
        //alert('server error()');
        reject(jqXHR);
      });

    // var xhttp = new XMLHttpRequest();
    // xhttp.onreadystatechange = function() {
    //   if (this.readyState == 4 && this.status == 200) {
    //     console.log(this.responseText);
    //   }
    // };
    //
    // xhttp.open("POST", serverUrl, true);
    // xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    // xhttp.send("fname=Henry&lname=Ford");

    //
    //     var payload = {
    //         a: 1,
    //         b: 2
    //     };
    //
    //     var formdata = new FormData();
    //     formdata.append( "json", JSON.stringify( payload ) );
    //
    //
    // fetch(serverUrl,{
    //     method: 'POST',
    //     headers: {
    //         'Accept': '*/*',
    //         'Content-Type' : 'application/x-www-form-urlencoded',
    //         //'Access-Control-Allow-Origin': '*',
    //         //'Access-Control-Allow-Methods': 'POST,GET,OPTIONS,PUT,DELETE',
    //         //'Access-Control-Allow-Headers': 'Content-Type,Accept',
    //     },
    //     mode : 'no-cors',
    //     //credentials: 'include',
    //     body: JSON.stringify(data)
    //     //body : {username: data.username, password: data.password}
    // })
    // .then((response) => response.json())
    // .then((responseJson) => {
    //     resolve(responseJson);
    // })
    // .catch((error) => {
    //    reject(error);
    // });
  });
}

export function FetchDataGet(endpoint_url, data) {
  const serverUrl = HOSTNAME + endpoint_url;

  return new Promise((resolve, reject) => {
    $.ajax({
      type: "GET",
      url: serverUrl,
      data
    })
      .done(function(res) {
        //console.log(res);
        resolve(res);
      })
      .fail(function(jqXHR, exception) {
        //alert('server error()');
        reject(jqXHR);
      });
  });
}
